import React, { useMemo } from "react";
import DatePicker from "react-datepicker";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";

import { format, isValid, parseISO } from "date-fns";
import { Input } from "semantic-ui-react";

import WithFormField from "../WithFormField";

export function ControlledDatePicker({
  name,
  initialDate,
  required,
  errorMessage,
  dataTest,
  ...props
}) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name: name,
    defaultValue: initialDate,
    rules: { required: { value: required, message: errorMessage } },
  });

  const value = useMemo(() => {
    return field.value && isValid(parseISO(field.value))
      ? parseISO(field.value)
      : null;
  }, [field.value]);

  return (
    <DatePicker
      showYearDropdown
      scrollableYearDropdown
      {...props}
      showTimeSelect={false}
      onChange={(v) => {
        field.onChange(v ? format(v, "yyyy-MM-dd") : null);
      }}
      selected={value}
      popperModifiers={[{ name: "arrow", options: { padding: 24 } }]}
      customInput={
        <Input
          fluid
          data-test={dataTest}
          ref={field.ref}
          onBlur={field.onBlur}
          error={Boolean(error)}
          icon="calendar outline"
        />
      }
    />
  );
}

ControlledDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  initialDate: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  dataTest: PropTypes.string,
};

ControlledDatePicker.defaultProps = {
  initialDate: null,
  required: false,
  errorMessage: "",
  dataTest: "controlled-date-picker",
};

export default WithFormField(ControlledDatePicker);
